import { Button } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue } from "recoil";
import { deviceAtom } from "recoil/deviceAtom";
import { sendMessage } from "utils/webview";
import { userAtom } from "recoil/userAtom";

export default function RequestPushNotificationButtonInSettings({
  disabled,
  clicked,
  onButtonClick,
}: {
  disabled: boolean;
  clicked?: boolean;
  onButtonClick?: () => void;
}) {
  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });
  const userState = useRecoilValue(userAtom);
  const [deviceState, setDeviceState] = useRecoilState(deviceAtom);
  const isGranted = clicked && deviceState.pushNotificationStatus === "granted";

  return (
    <Button
      variant="Solid"
      size={"md"}
      sx={{
        height: "46px",
        textAlign: "center",
        width: "200px",
      }}
      onClick={() => {
        sendMessage(
          JSON.stringify({
            event: "request_pushNotification",
            params: {
              enableGoToSetting: true,
              disableRequest: false,
            },
          })
        );
        setDeviceState((user) => ({
          ...user,
          pushNotificationStatus: "not set",
        }));
        if (onButtonClick) {
          onButtonClick();
        }
      }}
      disabled={isGranted || disabled}
    >
      {t_ui(!isGranted ? "알림 허용하기" : "알림 허용됨")}
    </Button>
  );
}
